import {
  type CustomerContainerPriceOptions,
  type PricingOption,
} from '@hungryroot/rest';

export const getPricePerServing = (
  quantity: number,
  priceOptions: CustomerContainerPriceOptions,
  servingSize: number
) => {
  const priceOption = priceOptions.pricing_options.find(
    (option: PricingOption) => {
      return (
        option.RECIPE_QUANTITY !== null &&
        option.RECIPE_QUANTITY.quantity === quantity &&
        option.RECIPE_QUANTITY.serving_size === servingSize
      );
    }
  );

  const recipeQuantity = priceOption?.['RECIPE_QUANTITY'];
  if (recipeQuantity === null) {
    return undefined;
  }
  return recipeQuantity;
};
